"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiProvider = exports.useApi = exports.ApiContext = void 0;
const react_1 = __importStar(require("react"));
const react_auth0_1 = require("@cmr/react-auth0");
exports.ApiContext = react_1.default.createContext(null);
const useApi = () => react_1.useContext(exports.ApiContext);
exports.useApi = useApi;
const ApiProvider = ({ children }) => {
    const { getTokenSilently, isAuthenticated, loading } = react_auth0_1.useAuth0();
    const apiFetch = react_1.useMemo(() => async (input, dispatch, action, init, meta) => {
        const token = await getTokenSilently();
        if (!token) {
            const error = new Error('Unable to acquire access token');
            if (dispatch && action)
                dispatch(action.failure({ error }, meta));
            throw error;
        }
        if (dispatch && action)
            dispatch(action.request(meta));
        const options = {
            ...(init || {}),
            headers: { ...((init === null || init === void 0 ? void 0 : init.headers) || {}), Authorization: `Bearer ${token}` },
        };
        try {
            const response = await fetch(input, options);
            if (!response.ok) {
                const error = new Error(response.statusText);
                if (dispatch && action)
                    dispatch(action.failure({
                        error,
                        statusCode: response.status,
                    }, meta));
                throw error;
            }
            let payload = null;
            try {
                payload = await response.json();
            }
            finally {
                if (dispatch && action)
                    dispatch(action.success(payload, meta));
                return payload;
            }
        }
        catch (error) {
            if (dispatch && action)
                dispatch(action.failure({ error }, meta));
            throw error;
        }
    }, [getTokenSilently]);
    return (react_1.default.createElement(exports.ApiContext.Provider, { value: {
            authReady: !loading && isAuthenticated,
            apiFetch,
        } }, children));
};
exports.ApiProvider = ApiProvider;
//# sourceMappingURL=hook.js.map